<template>
  <!-- <div class="body_wrapper"> -->
  <div id="signature-pad" class="signature-pad align-self-center">
    <div class="signature-pad--body">
      <canvas></canvas>
    </div>
    <div class="signature-pad--footer">
      <div class="description">Sign above with your mouse</div>

      <div class="signature-pad--actions">
        <button type="button" class="action-button clear" @click="clearPad" data-action="clear">Clear</button>
        <button type="button" class="action-button" data-action="undo" @click="undoPad">Undo</button>

      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import SignaturePad from 'signature_pad';

export default defineComponent({
  data() {
    return {
      signatureCanvas: null,
      signaturePad: null,
    };
  },
  mounted() {
    const wrapper = document.getElementById('signature-pad');
    const canvas = wrapper.querySelector('canvas');
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
    this.signatureCanvas = canvas;
    this.signaturePad = new SignaturePad(canvas, {
      // It's necessary to use an opaque color when saving image as JPEG;
      // this option can be omitted if only saving as PNG or SVG
      backgroundColor: 'rgb(255, 255, 255)',
    });
  },
  methods: {
    clearPad() {
      console.log('this.sig: ', this.signaturePad);
      this.signaturePad.clear();
    },
    undoPad() {
      const data = this.signaturePad.toData();

      if (data) {
        data.pop(); // remove the last dot or line
        this.signaturePad.fromData(data);
      }
    },
    hasSignature() {
      return !this.signaturePad.isEmpty();
    },
    getSignatureAsImage() {
      if (this.signaturePad.isEmpty()) {
        console.error('Please provide a signature first.');
        return null;
      } else {
        return new Promise((resolve, _reject) => {
          this.signatureCanvas.toBlob((blob) => {
            resolve(blob);
          }, 'image/png');
        });
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.align-self-center {
  align-self: center;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.body_wrapper {

  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 40vh;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  margin: 0;
  padding: 32px 16px;
  font-family: Helvetica, Sans-Serif;
  font-size: 17px;
}

.signature-pad {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  font-size: 10px;
  width: 100%;
  height: 100%;
  max-width: 700px;
  max-height: 460px;
  border: 3px solid #e8e8e8;
  background-color: #000;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27), 0 0 40px rgba(0, 0, 0, 0.08) inset;
  border-radius: 4px;
  padding: 16px;
}

.signature-pad::before,
.signature-pad::after {
  position: absolute;
  z-index: -1;
  content: "";
  width: 40%;
  height: 10px;
  bottom: 10px;
  background: transparent;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.4);
}

.signature-pad::before {
  left: 20px;
  -webkit-transform: skew(-3deg) rotate(-3deg);
          transform: skew(-3deg) rotate(-3deg);
}

.signature-pad::after {
  right: 20px;
  -webkit-transform: skew(3deg) rotate(3deg);
          transform: skew(3deg) rotate(3deg);
}

.signature-pad--body {
  min-height: 200px;
  position: relative;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  border: 1px solid #f4f4f4;
}

.signature-pad--body
canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
}

.description {
  color: #FFFFFF;
  font-size: 1.4em;
}

.action-button {
  font-size: 0.7em;
}

.signature-pad--footer {
  color: #C3C3C3;
  text-align: center;
  font-size: 1.9em;
  margin-top: 8px;
}

.signature-pad--actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-top: 8px;
  font-size: 1.4em;
  justify-content: center;
}

</style>
